"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettifyIfNumber = exports.numberFormatter = exports.emSuffix = exports.toPixels = exports.displayTimeLeft = exports.pluralize = exports.timestampNow = exports.getNumberWithOrdinal = void 0;
var lodash_1 = require("lodash");
var date_fns_timezone_1 = require("date-fns-timezone");
var date_fns_1 = require("date-fns");
var React = require("react");
exports.getNumberWithOrdinal = function (n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    var getOrdinal = React.createElement('sup', {}, s[(v - 20) % 10] || s[v] || s[0]);
    var number = React.createElement('div', {}, [n, getOrdinal]);
    return number;
};
exports.timestampNow = function () {
    var date = Date.now();
    var timeZone = 'Europe/London';
    var zonedDate = date_fns_timezone_1.convertToTimeZone(date, { timeZone: timeZone });
    return date_fns_1.getTime(zonedDate);
};
exports.pluralize = function (count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    return count + " " + noun + (count !== 1 ? suffix : '');
};
exports.displayTimeLeft = function (endDate, suffix) {
    if (suffix === void 0) { suffix = 'remaining'; }
    var daysLeft = Math.ceil((endDate - exports.timestampNow()) / 60000);
    if (daysLeft >= 1440) {
        var days = Math.ceil(daysLeft / 1440);
        return exports.pluralize(days, 'day') + " " + (suffix ? " " + suffix : undefined);
    }
    if (daysLeft >= 60) {
        var hours = Math.ceil(daysLeft / 60);
        return exports.pluralize(hours, 'hour') + " " + (suffix ? " " + suffix : undefined);
    }
    if (daysLeft >= 0 || daysLeft === -0) {
        return exports.pluralize(daysLeft, 'minute') + " " + (suffix ? " " + suffix : undefined);
    }
    return false;
};
function toPixels(value) {
    return value + "px";
}
exports.toPixels = toPixels;
function emSuffix(value) {
    return value + "em";
}
exports.emSuffix = emSuffix;
exports.numberFormatter = function (number, fractionDigits, thousandSeperator, fractionSeperator) {
    if (fractionDigits === void 0) { fractionDigits = 0; }
    if (thousandSeperator === void 0) { thousandSeperator = ','; }
    if (fractionSeperator === void 0) { fractionSeperator = '.'; }
    if ((number !== 0 && !number) || !lodash_1.isFinite(number)) {
        return number;
    }
    var frDigits = lodash_1.isFinite(fractionDigits) ? Math.min(Math.max(fractionDigits, 0), 7) : 0;
    var num = number.toFixed(frDigits).toString();
    var parts = num.split('.');
    var digits = parts[0].split('').reverse();
    var sign = '';
    if (num < 0) {
        sign = digits.pop();
    }
    var final = [];
    var pos = 0;
    while (digits.length > 1) {
        final.push(digits.shift());
        pos++;
        if (pos % 3 === 0) {
            final.push(thousandSeperator);
        }
    }
    final.push(digits.shift());
    return "" + sign + final.reverse().join('') + (frDigits > 0 ? fractionSeperator : '') + (frDigits > 0 && parts[1] ? parts[1] : '');
};
exports.prettifyIfNumber = function (stringOrNumber, decimals) {
    if (decimals === void 0) { decimals = 0; }
    if (typeof stringOrNumber === 'number') {
        return exports.numberFormatter(stringOrNumber, decimals);
    }
    return stringOrNumber;
};
//# sourceMappingURL=helpers.js.map